import { plans } from '../pricing'
import { formatRwf } from '../../utils/currency'
import type { LegalDoc } from '../../types/legal'

/** PLACEHOLDER — fee values marked [to confirm] require finance and compliance review. */
export const feeSchedule: LegalDoc = {
  slug: 'fees',
  title: 'Fee schedule',
  lastUpdated: '[date]',
  version: '[x.x]',
  summary: [
    'Kayko does not add a payment transaction fee. Payment provider charges may apply.',
    'Subscription prices are listed in RWF, per workspace.',
    'Annual billing costs 20% less than paying monthly.',
    'We will give notice before any fee changes [notice period to confirm].',
  ],
  sections: [
    {
      id: 'subscription-plans',
      title: 'Subscription plans',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] State whether prices include VAT and how billing periods work.' },
        {
          type: 'table',
          caption: 'Subscription plan prices',
          columns: ['Plan', 'Monthly price', 'Annual price', 'Effective monthly price'],
          rows: plans.map((p) => [p.name, formatRwf(p.monthly), formatRwf(p.annualTotal), formatRwf(p.annualMonthly)]),
        },
      ],
    },
    {
      id: 'payment-method-charges',
      title: 'Payment method charges',
      blocks: [
        {
          type: 'paragraph',
          text: '[Placeholder] Explain that Kayko adds no transaction fee and that providers may charge their own fees.',
        },
        {
          type: 'table',
          caption: 'Charges by payment method',
          columns: ['Payment method', 'Charged by', 'Fee', 'Notes'],
          rows: [
            ['Mobile money', '[Mobile money provider]', '[to confirm]', '[to confirm]'],
            ['Card', '[Card acquirer]', '[to confirm]', '[to confirm]'],
            ['Bank transfer', '[Receiving bank]', '[to confirm]', '[to confirm]'],
          ],
        },
      ],
    },
    {
      id: 'other-charges',
      title: 'Other charges',
      blocks: [
        {
          type: 'table',
          caption: 'Add-ons and services',
          columns: ['Item', 'Price', 'Notes'],
          rows: [
            ['Extra location', 'Contact us', '[to confirm]'],
            ['Additional users', 'Contact us', '[to confirm]'],
            ['POS hardware', 'Contact us', '[to confirm]'],
            ['Onboarding and data migration', 'Contact us', '[to confirm]'],
          ],
        },
      ],
    },
    {
      id: 'changes-to-fees',
      title: 'Changes to fees',
      blocks: [
        { type: 'paragraph', text: '[Placeholder] Describe how fee changes are decided and communicated.' },
        {
          type: 'callout',
          title: 'Notice periods',
          text: '[Placeholder] State the minimum notice given before a fee change [to confirm], how notice is sent, and the right to cancel before the change applies.',
        },
      ],
    },
  ],
}
